import React from "react";
import LabelForm from "components/RFQ/LabelForm/LabelForm";
import { getFileNameFromUrl, getOriginalFileName } from "utils/helpers";
import { FILE_UPLOAD_TYPES, FileUpload, UploadedFile } from "newui/components/FileUpload";
import type { UploadFile } from "types/storage.types";
import LabelWithGuideline from "newui/components/ui/LabelWithGuideline";
import { FileCard } from "newui/components/FileUpload/components/FileCard";

export interface QuoteFileProps {
	companyName?: string | null;
	disabled?: boolean;
	fileName?: string | null;
	isPreview?: boolean;
	quoteFilepath?: string | null;
	rfxId?: number | null;
	rfxInviteId?: number | null;
	submissionQuoteFiles?: UploadFile[] | null;
}

const QuoteFile: React.FC<QuoteFileProps> = ({
	quoteFilepath,
	companyName,
	fileName,
	rfxId,
	rfxInviteId,
	disabled = false,
	submissionQuoteFiles,
	isPreview = false,
}) => {
	// Prefer the server-supplied file_name; fall back to extracting from the S3 URL
	const serverFileName = quoteFilepath ? getFileNameFromUrl(quoteFilepath) : "";
	const urlDerivedName = getOriginalFileName(serverFileName);
	const originalFileName = fileName || urlDerivedName;

	const fileData = {
		name: !originalFileName ? "Quote template.xlsx" : originalFileName,
		path: quoteFilepath,
		description: `${companyName} has submitted a quote template. Please download this template and upload your response below.`,
		status: "uploaded",
	} as UploadedFile;

	// Pass submissionQuoteFiles directly — the new FileUpload's internal
	// convertFileAbleFileToUploadedFile() expects `UploadFile` shape, not the legacy
	// `FileUploadFile` shape that convertToFileUploadFormat() produces.
	const existingFiles: UploadFile[] = submissionQuoteFiles ?? [];

	return (
		<>
			<LabelWithGuideline label="Download quotation template" />
			<FileCard
				file={fileData}
				isPreview
				onDelete={null}
			/>

			<div className="my-4 w-full">
				<FileUpload
					allowFileTypes={["xlsx", "xls", "csv"]}
					multiple
					maxFileSizeMB={100}
					disabled={disabled}
					isPreview={isPreview}
					initialValue={existingFiles}
					uploadType={FILE_UPLOAD_TYPES.QUOTE_FILE_RESPONSE}
					extraData={{
						rfq_id: rfxId,
						rfxInviteId: rfxInviteId,
					}}
					supportsHardDelete
					onChange={() => {
						/* read-only in preview/disabled contexts — no parent state to sync */
					}}
				/>
			</div>
		</>
	);
};

export default QuoteFile;
